import { render, staticRenderFns } from "./aiWeightTongue.vue?vue&type=template&id=68c55e70&scoped=true&"
import script from "./aiWeightTongue.vue?vue&type=script&lang=ts&"
export * from "./aiWeightTongue.vue?vue&type=script&lang=ts&"
import style0 from "./aiWeightTongue.vue?vue&type=style&index=0&id=68c55e70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c55e70",
  null
  
)

export default component.exports